export enum ActionType {
    COACHING__CA__MIN_MAX = 'COACHING__CA__MIN_MAX',
    COACHING__CA__RESET = 'COACHING__CA__RESET',
    COACHING__CA__REMEMBER_STATUS_CHANGE = 'COACHING__CA__REMEMBER_STATUS_CHANGE',
    COACHING__CA__CHANGE_TRANSCRIPT_STATUS = 'COACHING__CA__CHANGE_TRANSCRIPT_STATUS',
    COACHING__CA__RECEIVE_MEETING_REQUEST_CONTEXT = 'COACHING__CA__RECEIVE_MEETING_REQUEST_CONTEXT',
    COACHING__CA__RECEIVE_RESULT_DATA = 'COACHING__CA__RECEIVE_RESULT_DATA',
}
